import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer id="contact" className="bg-[#0a0a0a] py-12 border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-center items-center text-[10px] tracking-[0.3em] uppercase opacity-40">
          <p>© 2025 Layer One Management. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;